export default __webpack_public_path__ + "static/media/slide_blank.be6a476e.png";